export const applyAuthorizationHeader = (axiosClient) => {
  const token = localStorage.getItem("access_token");
  if (token && token !== "null" && token !== "undefined") {
    axiosClient.defaults.headers.common.Authorization = token;
    return;
  }

  delete axiosClient.defaults.headers.common.Authorization;
};

export default {
  applyAuthorizationHeader,
};
